export default __webpack_public_path__ + "static/media/toy10.e9ca378d.jfif";